export default __webpack_public_path__ + "static/media/TonicLeaderboard.601398d5498a3080384b53465143747d.webp";